export class EditAlbumController {
  constructor($scope, $rootScope, $http, UserService, PhotoService, toastr, $timeout) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.http = $http;
    this.UserService = UserService;
    this.PhotoService = PhotoService;
    this.timeout = $timeout;
    this.toastr = toastr;
    this.scope.update=0;
    this.scope.del=0;
    this.scope.activityIndicatorOn = () => { $('<div id="imagelightbox-loading"><div></div></div>').appendTo('body') }
    this.scope.activityIndicatorOff = () => { $('#imagelightbox-loading').remove() }
    this.scope.overlayOn = () => { $('<div id="imagelightbox-overlay"></div>').appendTo('body') }
    this.scope.overlayOff = () => { $('#imagelightbox-overlay').remove() }

    this.scope.angle = [];

    this.init();
  }

  init() {
    this.UserService.getCurrentUser()
      .then((response) => {
        this.rootScope.currentUserProfile = response.data.data;
        this.setPhoto(this.rootScope.currentUserProfile.albumphotos);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setPhoto(photos) {
    _.forEach(photos, (photo) => {
      photo.version = "save";
      photo.status = "save";
    });

    this.scope.photos = photos;
  }

  addAlbumPhoto(file) {
    if (file && file.$error) {
      if(file.$error == "maxSize") {
        this.scope.step = 1;
        this.toastr.warning("Too big. El tamaño máximo es de 5 MB");
        return;
      }
      else {
        this.scope.step = 1;
        this.toastr.warning("Imagen de error");
        return;
      }
    }

    var photo = {_id: null, url: null, src: {}, version: null};
    photo._id = new Date().getTime();
    photo.user_id = this.rootScope.currentUserProfile._id;
    photo.version = "new";
    photo.status = "save";
    photo.approved = false;
    photo.origin = this.rootScope.currentUserProfile._id + "/" + file.name;
    photo.src = file;
    photo.type = file.type;

    var reader = new window.FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var image = new Image();
      image.onload = () => {
        if (image.width < 250 || image.height < 333) {
          this.toastr.warning('Tu foto debe ser por lo menos de 250x333');
          //this.scope.step = 1;
          return;
        }

        this.scope.photos.push(photo);
        this.scope.file_contents = reader.result;
        photo.src = reader.result;
        this.serverSave(photo)
      }
      image.src = reader.result;
    };
  }

  serverSave(paramdata) {
    this.scope.overlayOn();
    this.scope.activityIndicatorOn();
    var params = {
      url: paramdata.url,
      origin: paramdata.origin,
      id: paramdata.user_id,
      base64: paramdata.src,
      type: paramdata.type
    };

    this.PhotoService.editAlbumPhoto(params)
      .then((response) => { let data = response.data; let status = response.status; let headers = response.headers; let config = response.config;
        this.init();
        this.scope.activityIndicatorOff();
        this.scope.overlayOff();
    }).catch((response) => { let data = response.data; let status = response.status; let headers = response.headers; let config = response.config;
      console.log('error status: ' + status);
      //this.init();
      this.toastr.warning("error load image");
      this.scope.activityIndicatorOff();
      this.scope.overlayOff();
    })
  }

  rotatePhoto(id, deg) {
    var deg = 90 * deg;
    $('#' + id).removeClass();
    $('#' + id).addClass('album-img rotate' + deg);
    for (var len = this.scope.photos.length, i = 0; i < len; i++) {
      if (this.scope.photos[i]._id == id) {
        if(this.scope.photos[i].status=="save" || this.scope.photos[i].version=="save"){
          this.scope.photos[i].status = "save";
        //if angle exist
            for(let k=0, count=this.scope.angle.length; k<count;k++){
              if(this.scope.angle[k].id == id){
                this.scope.angle.splice(k, 1);
              }
            }
          var an = {};
          an.id = this.scope.photos[i]._id;
          an.angle = deg;
          this.scope.angle.push(an);
          this.scope.update++;
        }
        this.scope.photos[i].options = 'album-img rotate' + deg;
        this.scope.photos[i].angle = deg;
      }
    }
  }

  removePhoto(id) {
    for (var len = this.scope.photos.length, i = 0; i < len; i++) {
      if (this.scope.photos[i]._id == id) {
        this.scope.photos.splice(i, 1);
        this.scope.del++;
        len--;
      }
    }
    for (var len = this.scope.angle.length, i = 0; i < len; i++) {
      if(this.scope.angle[i].id==id)
      {
        this.scope.angle.splice(i, 1);
        this.scope.update--;
        len--;
      }
    }
  }

  saveAlbumPhoto() {
    if(this.scope.del!=0){
      this.scope.overlayOn();
      this.scope.activityIndicatorOn();
      var upload = [];
      this.scope.photos.forEach(page => {
        var up = {};
        up._id = page._id;
        up.origin = page.origin;
        up.url = page.url;
        upload.push(up);
      });

      this.rootScope.currentUserProfile.albumphotos = upload;

      this.UserService.updateUser(this.rootScope.currentUserProfile)
        .then((_res) => { let response = _res.data;
          this.toastr.info('Cambio realizado con exito');
          this.scope.status = "save";
          this.scope.del = 0;

          if(response.success){
            if(this.scope.update > 0){
              this.updatePhoto();
            }
              this.scope.overlayOff();
              this.scope.activityIndicatorOff();
          }
        })
        .catch((response) => { let error = response.data;
          this.toastr.warning(error);
          this.scope.overlayOff();
          this.scope.activityIndicatorOff();
          this.scope.status = "update";
        });

    } else {
      if(this.scope.update>0){
        this.updatePhoto();
      } else {
        this.toastr.warning('No hay cambios para guardar. Debes girar alguna fotografia en una dirección distinta a la original.');
      }
    }
  }

  updatePhoto(){
    this.scope.overlayOn();
    this.scope.activityIndicatorOn();
    this.rootScope.currentUserProfile.id = this.rootScope.currentUserProfile._id;
    var body = {body:this.rootScope.currentUserProfile, angle: this.scope.angle }

    this.PhotoService.updateAlbumPhoto(body)
      .then((_res) => { let response = _res.data;
        this.toastr.info('Cambio realizado con exito');
        this.scope.overlayOff();
        this.scope.activityIndicatorOff();
        this.scope.status = "save";
        this.scope.update = 0;
        this.scope.angle = [];
        this.setPhoto(response.data);

        this.scope.photos.forEach(photo => {
          photo.version = "save";
          photo.url += '?random'+Date.now();
        })
      })
      .catch((response) => { let error = response.data;
        this.toastr.warning(error.message);
        this.scope.overlayOff();
        this.scope.activityIndicatorOff();
        this.scope.status = "save";
        this.scope.update = 1;
      })
  }
}
